import { render, staticRenderFns } from "./finder.vue?vue&type=template&id=3b6b2952&"
import script from "./finder.vue?vue&type=script&lang=js&"
export * from "./finder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports